/**
 * 
 * 
 * 
 * 
 */
import { level } from '../const'

export default {
    SET_PLAY_STATE(state, isPlaying) {
        state.isPlaying = isPlaying
        isPlaying ?  this.commit('START_COUNT_TIME') : this.commit('STOP_COUNT_TIME')
    },
    SET_GAME_OVER(state, isGameOver) {
        state.gameOver = isGameOver
        this.commit('PAUSE_COUNT_TIME')
    },
    SET_GAME_WIN(state, isWin) {
        state.gameWin = isWin
        this.commit('PAUSE_COUNT_TIME')
    },
    CHANGE_STAGE(state, nextStage) {
        const MaxLevel = Object.keys(level).length
        state.level = nextStage > MaxLevel ? 1 : nextStage
    },
    SET_TOTAL_COUNT(state, { matrixSquare, level }) {
        state.totalCount = matrixSquare.row * matrixSquare.col - level.mine
        state.bombCount = level.mine
    },
    SET_BOMB(state, square) {
        state.bombs.push(square)
    },
    SET_FLAG(state, square) {
        const isHasSquare = state.flagCount.some(f => f.row === square.row && f.col === square.col)
        if (isHasSquare) {
            state.flagCount = state.flagCount.filter(f => f.row !== square.row || f.col !== square.col)
        } else {
            state.flagCount.push(square)
        }
    },
    SET_FIRST_SQUARE (state, square) {
        if( !state.firstClickSquare ) {
            state.firstClickSquare = square
        }
    },
    FLIP_TOTAL_COUNT(state) {
        state.totalCount--
    },
    START_COUNT_TIME(state) {
        let hour = 0
        let min  = 0
        let sec  = 0
  
        const formatTimer = time => {
          return time < 10 ?  '0' + time : time
        }      
  
        const setTimer = () => {
          if( sec === 60 ) {
            min += 1
            sec = 0
          }
          if ( min === 60 ) {
            hour += 1
            min = 0
          }
          sec += 1
          state.countTime = `${formatTimer(hour)}:${formatTimer(min)}:${formatTimer(sec)}`
        }
  
        state.timerInterval = setInterval(setTimer, 1000)
    },
    PAUSE_COUNT_TIME(state) {
        if( state.timerInterval ) clearInterval(state.timerInterval)
    },
    STOP_COUNT_TIME(state) {
        if( state.timerInterval ) clearInterval(state.timerInterval)
        state.countTime = '00:00:00'
    },
    IS_SHOW_MASK(state) {
        state.isShowMask = state
    },
    RESET_STATE(state) {
        state.isPlaying = false
        state.gameOver = false
        state.gameWin = false
        state.totalCount = 0
        state.flipCount = 0
        state.bombs = []
        state.bombCount = 0
        state.flagCount = []
        state.firstClickSquare = null
        state.win = false
        this.commit('STOP_COUNT_TIME')
    }
 }